import { Component } from '@angular/core';

@Component({
  selector: 'app-accessibility-bar',
  standalone: true,
  imports: [],
  templateUrl: './accessibility-bar.component.html',
  styleUrl: './accessibility-bar.component.scss',
})
export class AccessibilityBarComponent {}
